import React, { useCallback, useEffect, useState } from 'react';
import { Avatar, Badge, Dropdown, Menu, Modal, Spin, Button, Space, notification, Tooltip } from 'antd';
import { GoogleLogin } from '@react-oauth/google';
import jwt_decode from 'jwt-decode';
import useLogout from '../../hooks/useLogout';
import { BulbOutlined, BugOutlined, NotificationOutlined, ReadOutlined } from '@ant-design/icons';
import DynamicModal from '../../commonComponents/DynamicModal/DynamicModal';
import './header.scss';
import { LoadingOutlined, UserOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { getNewsArticles } from '../../content/news';
import { getUnreadCount, newsUserId, NEWS_SEEN_EVENT } from '../../utils/newsSeen';
import { useIsFetching } from 'react-query';
import InviteUser from '../../components/Signup/InviteUser';
import { useInviteUserToCompany } from '../../hooks/useSignup';
import SymbolsDictionary from '../SymbolsDictionary';
export default function Header({ user }) {
    const navigate = useNavigate();
    const location = useLocation();
    const [api, contextHolder] = notification.useNotification();
    const userId = newsUserId(user);
    const [newsUnreadCount, setNewsUnreadCount] = useState(0);

    const [showInviteUserModal, setShowInviteUserModal] = useState(false);
    const [openLoginModal, setOpen] = useState(true);
    const [openFeatureReqModal, setOpenFeatureReqModal] = useState(false);
    const [openBugReportModal, setOpenBugReportModal] = useState(false);
    const [openIconsDictionary, setOpenIconsDictionary] = useState(false);

    const InviteUserToCompanyMutation = useInviteUserToCompany();

    const HandleInviteUser = data => {
        InviteUserToCompanyMutation.mutateAsync([data?.companyCodes, data?.email])
            .then(() => {
                api.success({ message: 'User Invited successfully.' });
            })
            .catch(error => {
                console.log('Invite', { error });
                api.error({
                    message: 'Invite user failed',
                    description: error.message,
                });
                if (error?.response?.status === 401) logout();
            })
            .finally(() => {
                setShowInviteUserModal(false);
            });
    };

    const { logout } = useLogout();

    const refreshNewsUnread = useCallback(() => {
        setNewsUnreadCount(getUnreadCount(userId, getNewsArticles()));
    }, [userId]);

    useEffect(() => {
        refreshNewsUnread();
    }, [refreshNewsUnread, location.pathname]);

    useEffect(() => {
        const onSeenUpdate = () => refreshNewsUnread();
        window.addEventListener(NEWS_SEEN_EVENT, onSeenUpdate);
        return () => window.removeEventListener(NEWS_SEEN_EVENT, onSeenUpdate);
    }, [refreshNewsUnread]);
    const isFetching = useIsFetching();
    const itemHandler = ({ key }) => {
        if (key == 0) {
            logout();
        }
        if (key == 1) {
            navigate('/dashboard');
        }
        if (key == 2) {
            setShowInviteUserModal(true);
        }
    };

    const menu = (
        <Menu
            className="profileMenu"
            onClick={e => itemHandler(e)}
            items={[
                {
                    label: <span>Home</span>,
                    key: 1,
                },
                {
                    label: <span>Invite user</span>,
                    key: 2,
                },
                {
                    label: <span>Logout</span>,
                    key: 0,
                },
            ]}
        />
    );
    const antIcon = (
        <LoadingOutlined
            style={{
                fontSize: 40,
                // color:'rgb(31 158 255)'
            }}
            spin
        />
    );

    return (
        <>
            {contextHolder}
            <div className="header_main" id="headerBar">
                <img src="/images/logo.png" className="logo_img" alt="LOGO" />
                <div className="feature-request">
                    <Badge count={newsUnreadCount} size="small" offset={[-4, 2]} className="feature-request-news-badge">
                        <Tooltip title="What's New">
                            <Button className="feature-request-news" onClick={() => navigate('/news')}>
                                <NotificationOutlined />
                            </Button>
                        </Tooltip>
                    </Badge>
                    <Tooltip title="">
                        <Button className="feature-request-dictionary" onClick={() => setOpenIconsDictionary(true)}>
                            <ReadOutlined />
                        </Button>
                    </Tooltip>
                    <Button className="feature-request-feature" onClick={() => setOpenFeatureReqModal(true)}>
                        <BulbOutlined />
                    </Button>
                    <Button className="feature-request-bug" onClick={() => setOpenBugReportModal(true)}>
                        <BugOutlined />
                    </Button>
                    <p
                        style={{
                            margin: '0 10px',
                            backgroundColor: '#777777',
                            padding: '7px',
                            borderRadius: '13px',
                            color: 'white',
                        }}
                    >
                        {user?.name}
                    </p>
                </div>
                <div className="avatar_container">
                    <Dropdown overlay={menu} trigger={['click']} placement="bottomLeft" arrow>
                        <Avatar size={'large'} src={<UserOutlined />} style={{ backgroundColor: '#BFBFBF' }} />
                    </Dropdown>
                    <Spin spinning={isFetching} indicator={antIcon} />
                </div>
            </div>
            {openFeatureReqModal && (
                <DynamicModal
                    open={openFeatureReqModal}
                    width={'100%'}
                    closable={true}
                    close={() => setOpenFeatureReqModal(false)}
                    component={
                        <iframe
                            className="nocobase-embed-iframe"
                            src="https://tms.flixstock.com/public-forms/e6614wao74p"
                        ></iframe>
                    }
                />
            )}
            {openBugReportModal && (
                <DynamicModal
                    open={openBugReportModal}
                    width={'100%'}
                    closable={true}
                    close={() => setOpenBugReportModal(false)}
                    component={
                        <iframe
                            className="nocobase-embed-iframe"
                            src="https://tms.flixstock.com/public-forms/e6614wao74p"
                        ></iframe>
                    }
                />
            )}
            {openIconsDictionary && (
                <DynamicModal
                    open={openIconsDictionary}
                    width={'40%'}
                    closable={true}
                    title="Symbols"
                    close={() => setOpenIconsDictionary(false)}
                    component={<SymbolsDictionary />}
                />
            )}
            {showInviteUserModal && (
                <InviteUser
                    key="InviteUsersModal"
                    open={showInviteUserModal}
                    onCancel={() => setShowInviteUserModal(false)}
                    onOk={HandleInviteUser}
                />
            )}
        </>
    );
}
